import * as React from 'react';
import * as classNames from 'classnames';
import { CSSTransitionGroup } from 'react-transition-group';
import { observer } from 'mobx-react';
import { Notification } from '../../../stores';
import './style.css';

export interface NotificationsProps {
  notifications: Array<Notification>;
}

export interface NotificationsState {
  /* empty */
}

@observer
export class Notifications extends React.Component<
  NotificationsProps,
  NotificationsState
> {
  render() {
    const { notifications } = this.props;

    return (
      <CSSTransitionGroup
        className="notifications-wrapper"
        transitionName="notifications-change"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {notifications.map((notification, index) => (
          <div
            key={index}
            className={classNames(
              'notification',
              `${notification.type}-notification`
            )}
          >
            {notification.message}
          </div>
        ))}
      </CSSTransitionGroup>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/app/components/App/Notifications/index.tsx